import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { FeedbacksActions } from '@actions/index'
import * as fromApp from '@reducers/index'
import { HttpApiService } from '@services/http-api.service';
import { FeedbackModel, RequestModel, LocationModel } from '@models/index';


@Injectable()
export class FeedbacksEffects {

    searchFeedbacksByLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FeedbacksActions.searchFeedbacksByLocation),
            map(action => action.request),
            withLatestFrom(
                this.store.select(fromApp.getCurrentLocation),
                (request: RequestModel, location: LocationModel) => ({
                    ...request,
                    params: request.params + `&locationId=${location.id}`
                })
            ),
            switchMap((request) =>
                this.httpApiService.getRequest(request)
                    .pipe(
                        map((data) => data as { data: FeedbackModel[], total: number }),
                        map(data => FeedbacksActions.searchFeedbacksSuccess({ ...data })),
                        catchError(error => of(FeedbacksActions.feedbackError({ error: error.message })))
                    )
            )
        )
    );

    getTotalFeedbacksByLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FeedbacksActions.getTotalFeedbacksByLocation),
            map(action => action.request),
            withLatestFrom(
                this.store.select(fromApp.getCurrentLocation),
                (request: RequestModel, location: LocationModel) => ({
                    ...request,
                    params: request.params + `&locationId=${location.id}`
                })
            ),
            switchMap((request) =>
                this.httpApiService.getRequest(request)
                    .pipe(
                        map((data) => data as number),
                        map(total => FeedbacksActions.getTotalFeedbacksByLocationSuccess({ total })),
                        catchError(error => of(FeedbacksActions.feedbackError({ error: error.message })))
                    )
            )
        )
    );

    filterFeedbacksByLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FeedbacksActions.filterFeedbacksByLocation),
            map(action => action.request),
            withLatestFrom(
                this.store.select(fromApp.getCurrentLocation),
                (request: RequestModel, location: LocationModel) => ({
                    ...request,
                    params: request.params + `&locationId=${location.id}`
                })
            ),
            switchMap((request) =>
                this.httpApiService.postRequest(request)
                    .pipe(
                        map((data) => data as { data: FeedbackModel[], total: number }),
                        map(data => FeedbacksActions.searchFeedbacksSuccess({ ...data })),
                        catchError(error => of(FeedbacksActions.feedbackError({ error: error.message })))
                    )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private httpApiService: HttpApiService,
        private store: Store<any>
    ) { }
}